import { ArrowUpFromLine, CheckCheck, Reply, Send, Star, Trash2, X, File } from 'lucide-react';
import React, { Fragment, memo, useEffect, useMemo, useRef, useState } from 'react'
import VideoPlayer from '../components/VideoPlayer';
import AudioPlayer from '../components/AudioPlayer';
import LinkHighlighter from '../components/LinkHighlighter';
import BeautifiedCodeViewer from '../components/BeautifiedCodeViewer';
import MapCard from '../components/MapCard';

function UserChat(props) {

    const { chatMessages, highlightReply, senderContainerColor, receiverContainerColor, senderTextColor,
        receiverTextColor, messagesContainerRef, scrollToMessage, authUserId, checkFileType, openInNewTab, formatFile,
        handleReplyMessage, isProbablyCode, handleDeleteMessage, senderDateTextColor, receiverDateTextColor, color, senderLinkTextColor, receiverLinkTextColor, replyMessageData,
        sendButtonColor, setReplyMessageData, } = props
    const divRef = useRef()
    const [page, setPage] = useState(1);
    const pageSize = 10;
    const allChats = useMemo(() => {
        return chatMessages.flatMap(day => day)
            .sort((a, b) => new Date(b.date) - new Date(a.date));
    }, [chatMessages]);

    const visibleChats = useMemo(() => {
        return allChats.slice(0, page * pageSize);
    }, [allChats, page]);

    const [prevScrollHeight, setPrevScrollHeight] = useState(null);
    const handleScroll = () => {
        const el = divRef.current;
        if (!el) return;
        // ✅ proper bottom detection
        console.log("el.full", Math.round(-el.scrollTop + el.clientHeight) + 300 >= el.scrollHeight - 25)
        if (Math.round(-el.scrollTop + el.clientHeight) + 300 >= el.scrollHeight - 5) {
            const prevScrollHeight = el.scrollHeight;
            console.log('el.scrollTop + el.clientHeight', prevScrollHeight, Math.round(-el.scrollTop + el.clientHeight), el.scrollHeight - 25)


            setPrevScrollHeight(prevScrollHeight - 10); // record old height
            setPage((p) => p + 1);


        }
    };

    useEffect(() => {
        if (prevScrollHeight === null) return;
        const el = divRef.current;
        if (!el) return;

        requestAnimationFrame(() => {
            const newScrollHeight = el.scrollHeight;
            console.log("el scrollHeight:", newScrollHeight, prevScrollHeight);
            const diff = newScrollHeight - prevScrollHeight;
            el.scrollTop += diff; // ✅ keep same position
        });

        setPrevScrollHeight(null); // reset
    }, [page]);

    // alert(4077 >= 4053)
    console.log('visibleChats', visibleChats.length)

    return (
        <Fragment>
            <div ref={divRef} onScroll={handleScroll} className="flex-1 p-3 overflow-y-auto flex flex-col-reverse">
                {visibleChats.length > 0 && [...visibleChats].map((chat, chatIndex) => (
                    <div
                        ref={messagesContainerRef}

                        key={chatIndex + 1}>
                        {/* Date Divider */}
                        <div className="text-xs bg-primary/20 text-primary px-2 py-1 mx-auto my-4 backdrop-blur-sm border-b w-fit rounded border-gray-400">
                            {chat?.date}
                        </div>

                        {[...chat.chats].reverse().map((message, index) => (
                            <div
                                id={`message-${message._id}`}

                                key={index + 1}
                                className={`mb-2 flex flex-col ${message.sender === 'me' ? 'items-end' : 'items-start'} ${highlightReply == message._id ? 'transition-colors duration-1000 bg-yellow-100 rounded-xl' : ""}`}
                            >
                                <div className="relative group max-w-[75%]">
                                    {/* Message Bubble */}
                                    {message.isDeleted ?
                                        <div className={`p-2 text-xs italic rounded-xl shadow-md whitespace-pre-wrap break-words  
                                                                         ${message.sender === 'me'
                                                ? 'rounded-br-none '
                                                : 'rounded-bl-none '
                                            }`}
                                            style={{
                                                backgroundColor: message.sender === 'me' ? senderContainerColor : receiverContainerColor,
                                                color: message.sender === 'me' ? senderTextColor : receiverTextColor,
                                            }}>
                                            {message.sender === 'me' ? 'You deleted this message' : "This message was deleted"}
                                        </div>
                                        : <div
                                            className={`p-2 rounded-xl shadow-md whitespace-pre-wrap break-words  
                                                                         ${message.sender === 'me'
                                                    ? 'rounded-br-none '
                                                    : 'rounded-bl-none '
                                                }`}
                                            style={{
                                                backgroundColor: message.sender === 'me' ? senderContainerColor : receiverContainerColor,
                                                color: message.sender === 'me' ? senderTextColor : receiverTextColor,
                                            }}
                                        >

                                            {(message?.replyMessageId) && <div
                                                className={` p-2 rounded border-l-4 cursor-pointer shadow
                                                                        ${message.isSent
                                                        ? 'bg-gray-600 border-teal-600'
                                                        : 'bg-gray-100 border-teal-600'
                                                    }
                                                                        
                                                                        `}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    scrollToMessage(message.replyMessageId._id);
                                                }}
                                                style={{
                                                    // borderColor: message.sender !== 'me' ? senderContainerColor : receiverContainerColor,
                                                    // color: message.sender !== 'me' ? senderTextColor : receiverTextColor,
                                                }}
                                            >
                                                <div className={`text-xs font-medium mb-1 text-black ${message.sender === 'me' ? 'text-primary' : 'text-primary'
                                                    }`}>
                                                    {
                                                        message?.replyMessageId?.fromUserId?._id === authUserId ? "You" :
                                                            message?.replyMessageId?.fromUserId?.name}
                                                </div>
                                                <div className={`text-xs text-gray-700 truncate`}>
                                                    {message?.replyMessageId.messageContent}
                                                </div>
                                            </div>}



                                            {/* IMAGE */}
                                            {checkFileType(message.fileType) === 'image' && (
                                                <img
                                                    src={message.link}
                                                    alt="Preview"
                                                    className="max-h-32 rounded cursor-pointer mx-auto"
                                                    onClick={() => openInNewTab(message.link)}
                                                />
                                            )}

                                            {/* VIDEO */}
                                            {checkFileType(message.fileType) === 'video' && (
                                                <VideoPlayer src={message.link} color={color} />
                                            )}

                                            {/* AUDIO */}
                                            {checkFileType(message.fileType) === 'audio' && (
                                                <AudioPlayer src={message.link} color={color} />
                                            )}

                                            {/* DOCUMENT */}
                                            {checkFileType(message.fileType) === 'application' && (
                                                <div
                                                    className="flex items-center bg-gray-200 p-2 rounded cursor-pointer"
                                                    onClick={() => openInNewTab(message.link)}
                                                >
                                                    <File size={20} className="text-black mr-2" />
                                                    <p className="text-sm font-medium text-black">
                                                        Document{formatFile(message.link)}
                                                    </p>
                                                </div>
                                            )}
                                            {message.type === "L" && <  MapCard
                                                data={message.text}
                                            />}

                                            {/* TEXT / LINK / CODE */}
                                            {!isProbablyCode(message.text) &&
                                                checkFileType(message.fileType) !== 'image' &&
                                                message.text !== '' &&
                                                message.type !== 'L' && (
                                                    <div className="text-sm mt-1">
                                                        <LinkHighlighter
                                                            text={message?.text || ""}
                                                            color={
                                                                message.sender === 'me'
                                                                    ? senderLinkTextColor
                                                                    : receiverLinkTextColor
                                                            }
                                                        />
                                                    </div>
                                                )}

                                            {isProbablyCode(message.text) && (
                                                <BeautifiedCodeViewer code={message.text} />
                                            )}
                                        </div>
                                    }
                                    {/* Hover Actions */}
                                    {!message.isDeleted && <div
                                        className={`absolute top-1/2 -translate-y-1/2 z-10 flex items-center gap-2 px-2
                                                                            ${message.sender === 'me' ? 'right-full ml-2' : 'left-full mr-2'}
                                                                    opacity-0 group-hover:opacity-100 transition-opacity`}
                                    >
                                        <Reply onClick={() => {
                                            // console.log('handleReplyMessagehandleReplyMessage', message)
                                            handleReplyMessage(message)
                                        }
                                        } className="text-gray-400 hover:text-primary cursor-pointer" size={18} />
                                        {message.sender === 'me' && <Trash2
                                            onClick={() => {

                                                handleDeleteMessage(message)
                                            }}
                                            className="text-gray-400 hover:text-primary cursor-pointer"
                                            size={18}
                                        />}
                                    </div>}


                                </div>
                                {/* Timestamp & Read Receipt */}
                                <div
                                    className={`text-xs mt-1 flex gap-1 items-center ${message.sender === 'me' ? 'justify-end text-gray-600' : 'justify-start text-gray-800'}`}
                                    style={{
                                        color: message.sender === 'me' ? senderDateTextColor : receiverDateTextColor,
                                    }}
                                >
                                    {(message.sender === 'me' && message.isStared) && <span><Star fill='#eab308' className='text-yellow-500' size={10} /></span>}
                                    <span>{message.time}</span>
                                    {message.sender === 'me' && (
                                        <CheckCheck
                                            size={16}
                                            className={message.isRead ? 'text-blue-500' : 'text-gray-400'}
                                        />
                                    )}
                                    {message.sender !== 'me' && message.isStared && <span><Star fill='#eab308' className='text-yellow-500' size={10} /></span>}

                                </div>
                            </div>
                        ))}
                    </div>
                ))}
            </div>

            {replyMessageData && (
                <div className="px-4 py-2 bg-gray-100 border-b border-gray-200 flex items-start sm:items-center ">
                    <div className="w-1 h-12  rounded-full mr-3 flex-shrink-0"
                        style={{ backgroundColor: sendButtonColor || "#000" }}
                    ></div>

                    <div className="flex-1 min-w-0"> {/* min-w-0 allows text truncation */}
                        <div className="flex items-center justify-between gap-2">
                            <span className="text-xs font-medium text-gray-600 whitespace-nowrap">
                                Replying to
                                {replyMessageData.sender === "reciver" ? replyMessageData?.user.name : "You"}
                            </span>
                            <button
                                onClick={() => setReplyMessageData('')}
                                className="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
                            >
                                <X className="w-4 h-4" />
                            </button>
                        </div>

                        <p className="text-sm text-gray-800 mt-1 w-full line-clamp-2">
                            {replyMessageData?.text}
                        </p>
                    </div>
                </div>

            )}
            {/* Input */}

        </Fragment>
    )
}

export default memo(UserChat)
